import { Viewer } from "../main";
import { IFCFile, IFCHandler } from ".";
import { AmbientLight, Scene } from "three";
import { AssetType } from "../../../redux/assets-slice";
import { mergeBoundingBoxes } from "../utilities";

export class CADHandler {
  public scene: Scene;
  public viewer: Viewer;
  private ifcHandler: IFCHandler

  constructor(viewer: Viewer) {
    this.viewer = viewer;

    this.scene = new Scene();
    this.scene.add(new AmbientLight(0xFFFFFF));
    this.ifcHandler = new IFCHandler(this);
  }

  get picker() {
    return this.viewer.gpuPickers.default;
  }

  get handlers() {
    return [this.ifcHandler];
  }

  get numberOfFiles() {
    return this.handlers
      .map(x=> x.numberOfFiles)
      .reduce((previous, current) => previous + current, 0);
  }

  get combinedBoundingBox() {
    let boundingBox = null;
    this.handlers.map(x => x.combinedBoundingBox).forEach(bbox => {
      boundingBox = mergeBoundingBoxes(boundingBox, bbox);
    });

    return boundingBox;
  }

  get objects() {
    return this.handlers
      .reduce((previous, current) => [...previous, ...current.objects], []);
  }

  getByID(id): IFCFile {
    let file;
    this.handlers.forEach(handler => {
      if (file) return;
      file = handler.getByID(id);
    });

    return file;
  }

  async getProperties(event) {
    let properties;

    for (let handler of this.handlers) {
      const attributes = await handler.getProperties(event);
      if (!attributes) continue;
      properties = attributes;
    }

    return properties;
  }

  clearHighlight() {
    for (let handler of this.handlers) {
      handler.clearHighlight();
    }
  }

  reconcile(models) {
    let numAdded = 0;

    // Add/remove ifc files
    const ifcFiles = models.filter(x => x.type === AssetType.IFC);
    numAdded += this.ifcHandler.reconcile(ifcFiles);

    return numAdded;
  }

  update() {
    this.ifcHandler.update();
  }
}